export default __webpack_public_path__ + "assets/icon5-471dbeb.svg";